<div class="vadtallogin-page">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-12 order-lg-0 order-2">
                <div class="login-content">
                    <img src="../../../../assets/img/logo.svg" alt="logo" class="img-fluid loginlogo">
                    <h3 class="caption-login">{{loginConstant.HEADER_TEXT}}</h3>
                    <form [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
                        <div class="form-group mb-4">
                            
                            <label for="floatingInput">{{loginConstant.EMAIL}}<span class="asterisk">*</span></label>
                            <input formControlName="emailAddress" type="text" class="form-control"
                                placeholder="Enter your Email ID" 
                                [ngClass]="{ 'is-invalid': submitted && loginFormControl['emailAddress'].errors }" />
                            <span class="text-danger"
                                *ngIf="submitted && loginFormControl['emailAddress'].errors?.['required']">Email is
                                required</span>
                            <span class="text-danger"
                                *ngIf="submitted && loginFormControl['emailAddress'].errors?.['pattern']">Email is
                                invalid</span>
                        </div>
                        <div class="form-group mb-0">
                            <label for="floatingInput">{{loginConstant.PASSWORD}}<span class="asterisk">*</span></label>
                            <div class="input-group">
                                <input formControlName="password" [type]="IsShowPassword ? 'text' : 'password'"
                                    class="form-control" placeholder="Enter your Password"
                                    [ngClass]="{ 'is-invalid': submitted && loginFormControl['password'].errors }" />
                                <div _ngcontent-fuk-c6="" class="input-group-append">
                                    <div _ngcontent-fuk-c6="" class="input-group-text">
                                        <span _ngcontent-fuk-c6=""
                                            [class]="IsShowPassword ? 'fa fa-eye-slash' :'fa fa-eye'"
                                            (click)="showPassword()"></span>
                                    </div>
                                </div>
                            </div>
                            <span class="text-danger"
                                *ngIf="submitted && loginFormControl['password'].errors?.['required']">Password is
                                required</span>
                        </div>
                        <div class="mb-3 mt-2 d-flex align-items-center justify-content-between g-3 flex-wrap">
                            <div class="form-check remember-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckIndeterminate"
                                    formControlName="rememberMe">
                                <label class="form-check-label" for="flexCheckIndeterminate">
                                    {{loginConstant.REMEMBER_ME}}
                                </label>
                            </div>
                            <a class="forgot-link"
                                [routerLink]="['/forgot-password']">{{loginConstant.FORGOT_PASSWORD}}</a>
                        </div>
                        <button class="btn btn-primary login-btn mt-4 mb-5"
                            type="submit">{{loginConstant.LOGIN}}</button>
                    </form>
                </div>
            </div>
            <div class="col-lg-6 col-12 order-lg-0 order-1">
                <div class="login-rightside">
                    <img src="../../../../assets/img/login-rightimg.jpg" alt="login rightimg" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</div>